import script from "./Balance.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance.vue?vue&type=script&setup=true&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=4e3f2dc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3f2dc0"]])

export default __exports__